import { COLOR_OPTIONS } from 'config/style';
import STTypo, { STTypoModels } from 'core/shared/typo';
import type { Feature, Point } from 'geojson';
import RegionalOverviewMycotoxinFieldLevelType from '@features/regional-overview/components/regional-overview-mycotoxin-field-level-type/regional-overview-mycotoxin-field-level-type';
import type { RegionalOverviewProperties } from 'querys/regional-overview/regional-overview.query.models';
import type React from 'react';
import { regionalMycotoxinLevels } from '../regional-overview-mycotoxin.models';

interface RegionalOverviewMycotoxinFieldsClusteredContainerProps {
  fieldInfo: Feature<Point, RegionalOverviewProperties>;
  handleClickField: () => void;
}

const RegionalOverviewMycotoxinFieldInfoComponent: React.FC<RegionalOverviewMycotoxinFieldsClusteredContainerProps> = ({
  fieldInfo,
  handleClickField
}) => {
  const fieldRiskLevel = regionalMycotoxinLevels.find(r => r.value === fieldInfo.properties.risk);

  return (
    <div
      data-testid={`regional-overview-mycotoxin-fields-clustered-list-item-${fieldInfo.properties.name}`}
      onClick={handleClickField}
      className='regional-overview-mycotoxin-fields-clustered__wrapper-fields__field-info'>
      <div className='regional-overview-mycotoxin-fields-clustered__wrapper-fields__field-info__property-info'>
        <STTypo type={STTypoModels.TypeOptions.P2} color={COLOR_OPTIONS.NEUTRAL_60}>
          {fieldInfo.properties.property_name}
        </STTypo>
        <STTypo type={STTypoModels.TypeOptions.P1} color={COLOR_OPTIONS.NEUTRAL_80} fontWeight={500}>
          {fieldInfo.properties.name}
        </STTypo>
      </div>
      <RegionalOverviewMycotoxinFieldLevelType fieldRiskLevel={fieldRiskLevel} />
    </div>
  );
};

export default RegionalOverviewMycotoxinFieldInfoComponent;
